import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const BatterySystem = () => {
  return (
    <section id="battery" className="py-24 bg-green-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          
          <div className="lg:w-1/2 space-y-8">
            <div className="inline-flex items-center bg-green-900 px-4 py-2 rounded-full">
              <SafeIcon icon={FiIcons.FiBattery} className="text-lime-400 mr-2 text-xl" />
              <span className="font-bold uppercase tracking-wide text-sm">Universal Power</span>
            </div>
            
            <h2 className="text-4xl lg:text-6xl font-black uppercase tracking-tighter leading-none">
              One Core.<br/>
              <span className="text-lime-400">Infinite</span><br/>
              Possibilities.
            </h2>
            
            <p className="text-green-100 text-lg max-w-lg leading-relaxed">
              The VoltYard 40V MAX battery system powers over 50+ tools in our heavy-duty lineup. Snap it in, power up, and get the job done without the hassle of gas.
            </p>
            
            <div className="grid grid-cols-2 gap-6 pt-4">
              <div className="border-l-4 border-lime-400 pl-4">
                <p className="text-3xl font-black">50+</p>
                <p className="text-sm text-green-200 uppercase font-bold tracking-wide">Compatible Tools</p>
              </div>
              <div className="border-l-4 border-lime-400 pl-4">
                <p className="text-3xl font-black">45<span className="text-xl">min</span></p>
                <p className="text-sm text-green-200 uppercase font-bold tracking-wide">Rapid Charge</p>
              </div>
            </div>
          </div>

          <div className="lg:w-1/2 relative w-full aspect-square max-w-md mx-auto">
            {/* Abstract representation of central battery connected to tools */}
            <div className="absolute inset-0 bg-green-900 rounded-full opacity-20 animate-pulse"></div>
            <div className="absolute inset-4 bg-green-700 rounded-full shadow-2xl flex items-center justify-center border-4 border-green-600">
               <div className="text-center">
                  <SafeIcon icon={FiIcons.FiBatteryCharging} size={80} className="text-lime-400 mx-auto mb-2" />
                  <span className="block font-black text-2xl uppercase tracking-widest">40V MAX</span>
               </div>
            </div>
            
            {/* Tool nodes orbiting */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-slate-900 p-4 rounded-full border-2 border-lime-400 shadow-lg">
              <SafeIcon icon={FiIcons.FiWind} size={24} className="text-white" />
            </div>
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 bg-slate-900 p-4 rounded-full border-2 border-lime-400 shadow-lg">
              <SafeIcon icon={FiIcons.FiScissors} size={24} className="text-white" />
            </div>
            <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 bg-slate-900 p-4 rounded-full border-2 border-lime-400 shadow-lg">
              <SafeIcon icon={FiIcons.FiMaximize} size={24} className="text-white" />
            </div>
            <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 bg-slate-900 p-4 rounded-full border-2 border-lime-400 shadow-lg">
              <SafeIcon icon={FiIcons.FiSun} size={24} className="text-white" />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default BatterySystem;